import { graphql } from '~publish/graphql'
import type { FragmentOf } from '~publish/graphql'

/**
 * Everything a conversation row reads off the inbox `Conversation` node.
 *
 * Selected on the interface rather than on `MessageConversation`, so the same
 * card can list comment and mention threads if they ever join the inbox.
 * `replyWindow` is a DM-only field and stays out for the same reason; the row
 * will pick it up through an inline fragment when the reply-window pill lands.
 *
 * Unmasked (`@_unmask`) because the card, the list and the display adapter all
 * read plain fields off it, and there is no context layer between them.
 *
 * Lives in `fragments/` so the document scanner collects it: a plain `.ts`
 * elsewhere would not be, and the query spreading it would fail validation.
 */
export const ConversationCard_Conversation = graphql(/* GraphQL */ `
  fragment ConversationCard_Conversation on Conversation @_unmask {
    __typename
    id
    channelId
    serviceType
    status
    isSpam
    lastActivityAt
    lastInboundAt
    participants {
      isOwner
      isActive
      serviceId
      author {
        name
        username
        avatar
        letterAvatar {
          letter
          textColor
          backgroundColor
        }
      }
    }
    preview {
      itemId
      isOwnMessage
      contentType
      text
      publishedAt
      author {
        name
        username
      }
      send {
        state
      }
    }
    readState {
      unreadCount
      lastReadAt
    }
    ... on MessageConversation {
      replyWindow {
        expiresAt
      }
    }
  }
`)

export type ConversationCardData = FragmentOf<
  typeof ConversationCard_Conversation
>
